import script from "./SourceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceSettings.vue?vue&type=script&setup=true&lang=js"

import "./SourceSettings.vue?vue&type=style&index=0&id=b60c868c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b60c868c"]])

export default __exports__